import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  standalone: true,
  selector: 'app-modal-id-retirement',
  imports: [CommonModule],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  templateUrl: './modal-id-retirement.component.html',
  styleUrls: ['./modal-id-retirement.component.scss'],
})
export class ModalIdRetirementComponent {
  @Input() open = false;
  @Input() isForeigner = false;

  @Output() closed = new EventEmitter<boolean | null>();

  get heading(): string {
    return this.isForeigner
      ? 'Aposentadoria para entidade estrangeira'
      : 'Confirmar alteração para CPF/CNPJ';
  }

  get bodyText(): string {
    if (this.isForeigner) {
      return 'Ao selecionar esta opção, a aposentadoria dos créditos será atribuída a uma entidade estrangeira. Tem certeza de que deseja continuar?';
    }

    return 'Você está desmarcando a opção de entidade estrangeira. A aposentadoria será vinculada a um CPF ou CNPJ nacional. Tem certeza de que deseja continuar?';
  }

  onCancel(): void {
    this.closed.emit(this.isForeigner ? false : true);
  }

  onConfirm(): void {
    this.closed.emit(this.isForeigner ? true : false);
  }

  onModalDismiss(): void {
    this.closed.emit(null);
  }
}
